import { BsCheck2 } from "react-icons/bs";
import { MdOutlineArrowOutward } from "react-icons/md";
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from "react";
import { CustomDot } from "../Charts/CustomBadge";

export default function PrimaryButton({
  text = "Proceed",
  onClick,
  disabled = false,
  className = "",
  textClassName = "",
  iconClassName = "",
  icon = <MdOutlineArrowOutward className="w-8 h-8" />,
  type = "button",
  noIcon = false,
  btnType = "primary",
  verified = false,
  filtered = false,
  loading = false,
  iconOnleft = false,
  children,
  ...rest
}) {
  const bg = "#A33434";
  const btnIcon = loading ? (
    <LoadingOutlined />
  ) : verified ? (
    <BsCheck2 />
  ) : filtered ? (
    <CustomDot color={"#A33434"} size={7} />
  ) : btnType === "primary" || btnType === "ghost" ? (
    icon
  ) : null;

  const btnClasses = `my-auto font-manrope relative font-bold rounded-full w-full sm:w-auto px-6 text-center h-[42px] transition-all`;

  const [isHovered, setIsHovered] = useState(false);

  let content;
  switch (btnType) {
    case "primary":
      content = (
        <button
          type={type}
          onClick={disabled ? () => {} : onClick}
          disabled={loading || disabled}
          className={`custom-button min-w-fit flex items-center text-[#ffffff] bg-[${bg}] hover:!bg-red-800 ${
            isHovered ? "!bg-red-800" : ""
          } border-none text-xl !transition-all ${disabled ? "cursor-not-allowed" : ""} ${
            iconOnleft ? "ms-[45px]" : ""
          } ${btnClasses} ${className}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onMouseOver={() => setIsHovered(true)}
          {...rest}
        >
          <div className="flex items-center justify-center gap-2 w-full">
            {children || <div className={`${textClassName} text-lg whitespace-nowrap`}>{text}</div>}
            {verified && noIcon && <BsCheck2 />}
          </div>
          {(!noIcon) && (
            <div
              className={`bg-[${bg}] absolute ${
                iconOnleft ? "left-[-42px]" : "right-[-42px]"
              } hover:bg-red-800 ${
                isHovered ? "bg-red-800" : ""
              } my-auto mx-auto p-2 rounded-full flex items-center justify-center h-[42px] w-[42px] ${iconClassName}`}
            >
              {btnIcon}
            </div>
          )}
        </button>
      );
      break;
    case "ghost":
      content = (
        <button
          type={type}
          onClick={disabled ? () => {} : onClick}
          disabled={loading || disabled}
          className={` min-w-fit flex items-center text-[#A33434] bg-transparent hover:!bg-transparent ${
            isHovered ? "!bg-transparent" : ""
          } border-none text-xl !transition-all ${disabled ? "cursor-not-allowed" : ""} ${
            iconOnleft ? "ms-[45px]" : ""
          } !px-1 ${btnClasses} ${className}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onMouseOver={() => setIsHovered(true)}
          {...rest}
        >
          <div className="flex items-center justify-center gap-2 w-full">
            {children || <div className={`${textClassName} text-lg whitespace-nowrap`}>{text}</div>}
            {verified && noIcon && <BsCheck2 />}
          </div>
          {!noIcon && (
            <div
              className={`bg-[${bg}] absolute ${
                iconOnleft ? "left-[-42px]" : "right-[-42px]"
              } hover:bg-red-800 ${
                isHovered ? "bg-red-800" : ""
              } my-auto mx-auto rounded-full flex items-center justify-center h-[35px] w-[35px] ${iconClassName}`}
            >
              {btnIcon}
            </div>
          )}
        </button>
      );
      break;
    default:
      content = (
        <button
          type={type}
          onClick={disabled ? () => {} : onClick}
          disabled={loading || disabled}
          className={`custom-button text-[#000000] disabled:cursor-not-allowed ${
            filtered ? "border-[3px]" : "border-2"
          } border-[#A33434] ${
            !disabled ? "hover:!bg-red-800 hover:text-[#ffffff] " : "bg-gray-100"
          } text-lg ${btnClasses} ${className}`}
          {...rest}
        >
          <div className="flex items-center justify-center gap-2 w-full">
            {iconOnleft && btnIcon}
            {children || <div className={`${textClassName} whitespace-nowrap`}>{text}</div>}
            {!iconOnleft && btnIcon}
          </div>
        </button>
      );
  }
  return content;
}
